import React from 'react';
import { FixedWithContainer } from '@/presentation/modules/common/CardBoardStyled';
import {
  Card,
  CardBody,
  CardContainer,
  CardHeader,
  CardList,
  CardRow,
  CardText,
  Separator,
  TornEdgeBottom,
  TornEdgeTop
} from './PaymentDetails.styled';
import DateHelpers from '@/core/helpers/DateHelper';
import ReusableInfo from '@/presentation/reusables/Info';
import Button from '@/presentation/reusables/Button';
import TextHelper from '@/core/helpers/TextHelper';
import ModuleContainer from '@/presentation/components/Container';
import { SubsectionHeader } from '@/presentation/reusables/SectionHeader';

interface PaymentDetailsViewProps {
  goToPayments: () => void;
  paymentDetail: any;
  discountPayment: boolean;
}

const PaymentDetailsView = (props: PaymentDetailsViewProps) => {
  const { goToPayments, paymentDetail, discountPayment } = props;

  const { response, time, payments } = paymentDetail;
  const { order } = response.response;

  const payDate = new Date(
    response.response.order[0].dateTransaction.substr(0, 4),
    response.response.order[0].dateTransaction.substr(4, 2) - 1,
    response.response.order[0].dateTransaction.substr(6, 2)
  );

  const paymentMethod = () => {
    switch (response.response.card.brand) {
      case 'VS':
        return 'Visa';
      case 'AE':
        return 'AMEX';
      case 'MC':
        return 'MC';
      case 'DN':
        return 'Dinners';
      default:
        return '-';
    }
  };

  return (
    <ModuleContainer containerType="subsection">
      <FixedWithContainer>
        <div className="payments">
          <SubsectionHeader
            title="Pago realizado con éxito"
            onClick={goToPayments}
          />
          <ReusableInfo
            backgroundColor="#D5E5F0"
            iconColor="#161D1F"
            style={{ marginTop: '8px', marginBottom: '24px' }}
            text="<span>El monto pagado se verá reflejado en tu estado de cuenta en un plazo máximo de 30 minutos. </span>Puedes descargar tu boleta por cada Item de pago en UTP+portal, luego de 24 horas de haber realizado el pago."
            textColor="#161D1F"
          />
          <CardContainer>
            <TornEdgeTop />
            <Card>
              <CardHeader>
                <CardRow>
                  <CardText>Monto pagado</CardText>
                  <CardText>S/. {Number(order[0].amount).toFixed(2)}</CardText>
                </CardRow>
                <CardRow>
                  <CardList>
                    <li>Número de transacción</li>
                  </CardList>
                  <p>{order[0].orderNumber}</p>
                </CardRow>
                <CardRow>
                  <CardList>
                    <li>Fecha de pago</li>
                  </CardList>
                  <p>{DateHelpers.extendedDate(payDate.getTime())}</p>
                </CardRow>
                <CardRow>
                  <CardList>
                    <li>Hora</li>
                  </CardList>
                  <p>{time}</p>
                </CardRow>
              </CardHeader>
              <Separator dark />
              <CardBody>
                <CardText>Resumen de pago</CardText>
                {discountPayment ? (
                  <CardRow>
                    <CardList>
                      <li>{TextHelper.capitalize('Ciclo Completo')}</li>
                    </CardList>
                    <p>S/. {Number(order[0].amount).toFixed(2)}</p>
                  </CardRow>
                ) : (
                  <>
                    {payments
                      .filter((p: any) => p && Object.keys(p).length > 0)
                      .sort(
                        (a: any, b: any) =>
                          Number(a.itemNumber) - Number(b.itemNumber)
                      )
                      .map((p: any) => (
                        <CardRow key={p.itemNumber}>
                          <CardList>
                            <li>{TextHelper.capitalize(p.name)}</li>
                          </CardList>
                          <p>
                            S/.{' '}
                            {(Number(p.amount) + Number(p.recharge)).toFixed(2)}
                          </p>
                        </CardRow>
                      ))}
                  </>
                )}

                <Separator />
                <CardRow>
                  <CardList>
                    <li>Metodo de pago</li>
                  </CardList>
                  <p>{paymentMethod()}</p>
                </CardRow>
                <CardRow>
                  <CardList>
                    <li>Cantidad de cuotas</li>
                  </CardList>
                  <p>{order[0].installment}</p>
                </CardRow>
              </CardBody>
            </Card>
            <TornEdgeBottom />
          </CardContainer>
          <Button
            style={{
              marginTop: '24px'
            }}
            data-test-id="button-back"
            text="Volver a pagos"
            onClick={goToPayments}
          />
        </div>
      </FixedWithContainer>
    </ModuleContainer>
  );
};

export default PaymentDetailsView;
